import React from 'react';
import IndexPagination from '../pagination';
import RowsPerPageSelect from '../rows_per_page';

const IndexTableFooter = () => (
  <div className="Table-footer">
    <IndexPagination />
    <RowsPerPageSelect />
  </div>
);

export default IndexTableFooter;
